import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FaGithub, FaLinkedinIn, FaMediumM } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { profile } from "../data/portfolio";
import "./Footer.css";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <Container fluid className="footer">
      <Container>
        <Row className="align-items-center g-3">
          <Col md={6}>
            <p>© {year} Sagnik Pal — designed and built by me.</p>
          </Col>
          <Col md={6}>
            <ul className="footer-icons">
              <li>
                <a href={profile.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                  <FaGithub />
                </a>
              </li>
              <li>
                <a href={profile.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                  <FaLinkedinIn />
                </a>
              </li>
              <li>
                <a href={profile.medium} target="_blank" rel="noopener noreferrer" aria-label="Medium">
                  <FaMediumM />
                </a>
              </li>
              <li>
                <a href={`mailto:${profile.email}`} aria-label="Email">
                  <HiOutlineMail />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Footer;
